import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";

import Tabs from "../../Components/Tabs";
import AdminHeader from "../Admin/Components/AdminHeader";
import AdminSidebar from "./Components/AdminSidebar";
import AdminBookingList from "./Components/AdminBookingList";
import { BookingItemType } from "../../Constants/Interfaces";
import PanelWrapper from "../User/PanelWrapper";

const MessagesPage = () => {
  const tabs = ["Bookings", "History"];

  const [selectedList, setSelectedList] = useState("Paid");
  const [searchText, setSearchText] = useState("");

  return (
    <PanelWrapper type="admin">
      <div className="container">
        <div className="page-header">
          <h2>Bookings</h2>
        </div>

        <div className="page-content-card">
          <div className="content-card-header">
            <h3>List of bookings</h3>

            {/* <div className="filter-area">
                  <div className="form-group">
                    <div className="with-icon">
                      <FontAwesomeIcon icon={faSearch} />
                      <input
                        type="text"
                        className="form-control"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                      />
                    </div>
                  </div>
                </div> */}
          </div>

          <AdminBookingList search="" />

          {/*  */}
        </div>
      </div>
    </PanelWrapper>
  );
};

export default MessagesPage;
